module.exports = __webpack_public_path__ + "fonts/iconfont.8c1a1095.woff";